import {Divider} from '@sdox/ui'

import type {XcNwBlock_BlockDividerType_Fragment} from '@sdox/api'

type BlockDividerProps = XcNwBlock_BlockDividerType_Fragment

// props are here for code consistency
// eslint-disable-next-line @typescript-eslint/no-unused-vars
export const BlockDivider = (props: BlockDividerProps) => {
  return <Divider />
}
